<template>
  <div>
    <div class="base-page" v-if="platform == 'pc'">
      <div class="pc" v-for="field in formList" :key="field.fieldName">
        <sk-select
          v-if="field.displayType == 4"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-radio
          v-if="field.displayType == 3"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-select
          v-if="field.displayType == 6"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox
          v-if="field.displayType == 5"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-img
          v-if="field.displayType == 7"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
        />
        <sk-file
          v-if="field.displayType == 8"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
        />
        <sk-input
          v-if="field.displayType == 1 && field.fieldType !== 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-input
          v-else-if="field.displayType == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-textarea
          v-if="field.displayType == 2"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-date-picker
          v-if="field.fieldType == 'DATETIME'"
          :field="field"
          :check-flag="field.checkFlag"
          :field-value.sync="field.value"
        />
        <sk-line v-if="field.fieldType === 'LINE'" />
        <sk-desc v-if="field.fieldType === 'DESC'" :field="field" />
        <sk-radio-img
          v-if="field.type == 9"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-img
          v-if="field.type == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-policy
          v-if="field.fieldType == 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <div v-if="field.fieldType == 'TEXT' && field.egValue" class="eg-tips">
          {{ field.egValue }}
        </div>
      </div>
    </div>
    <div class="base-page" v-if="platform == 'wap'">
      <div class="wap" v-for="field in formList" :key="field.fieldName">
        <sk-select-wap
          v-if="field.displayType == 4"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-radio-wap
          v-if="field.displayType == 3"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-select-wap
          v-if="field.displayType == 6"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-wap
          v-if="field.displayType == 5"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-img-wap
          v-if="field.displayType == 7"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
        />
        <sk-file-wap
          v-if="field.displayType == 8"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-input-wap
          v-if="field.displayType == 1 && field.fieldType !== 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-input-wap
          v-else-if="field.displayType == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :sms-type="'customForm'"
          :isPassword="field.fieldName == 'password'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-textarea-wap
          v-if="field.displayType == 2"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-date-picker-wap
          v-if="field.fieldType == 'DATETIME'"
          :field="field"
          :check-flag="field.checkFlag"
          :field-value.sync="field.value"
        />
        <sk-line-wap v-if="field.fieldType === 'LINE'" />
        <sk-desc-wap v-if="field.fieldType === 'DESC'" :field="field" />
        <sk-radio-img-wap
          v-if="field.type == 9"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-checkbox-img-wap
          v-if="field.type == 10"
          :check-flag="field.checkFlag"
          :field="field"
          :field-style="extraItem.extras('formfield.model') || 'style1-wap'"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <sk-policy-wap
          v-if="field.fieldType == 'POLICY'"
          :check-flag="field.checkFlag"
          :field="field"
          :field-value.sync="field.value"
          :field-result.sync="field.result"
        />
        <div v-if="field.fieldType == 'TEXT' && field.egValue" class="eg-tips">
          {{ field.egValue }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "baseComponent",
  data() {
    return {};
  },
  props: {
    formList: Array,
    platform: String,
    extras: Object,
  },
};
</script>
